/* ––
 * ––– Imports
 * –––––––––––––––––––––––––––––––– */
import Display from 'components/Generic/Display';
import Header from 'components/Layout/Header';
import CampaignBanner from 'components/Layout/Banner';
import Footer from 'components/Layout/Footer';

import Button from '@mui/material/Button';
import Container from '@mui/material/Container';
import useTheme from '@mui/material/styles/useTheme';
import Typography from '@mui/material/Typography';

import React, { useMemo } from 'react';
import CookieConsent from 'react-cookie-consent';
import ReactHtmlParser from 'react-html-parser';

import CampaignRecord from 'records/campaign_record';
import Company from 'records/company';

/* ––
 * ––– Component
 * –––––––––––––––––––––––––––––––– */
function UnavailableCampaignPageIndex() {
  /* –– Data fetching
   * –––––––––––––––––––––––––––––––– */
  const theme = useTheme();
  const { campaign, company } = useMemo(() => ({
    company:  new Company(window.UNAVAILABLEPAGE.company),
    campaign: new CampaignRecord(window.UNAVAILABLEPAGE.campaign),
  }), []);
  const cookieNotification = useMemo(() => company.parameters.cookieNotification, [company]);

  /* –– Render
   * –––––––––––––––––––––––––––––––– */
  return (
    <>
      <header>
        <Header name={company.name} logo={company.logo} />
      </header>

      <main>
        <CampaignBanner imageUrl={campaign.jobBanner} />

        <Container sx={{ mt: 9, textAlign: 'center', [theme.breakpoints.down('sm')]: { mt: 5 } }}>
          <Typography variant="h5" fontWeight="bold">
            {t('eos.landing_page.text.close_to_new_applications')}
          </Typography>
          <Button
            variant="contained"
            disableElevation
            size="medium"
            href="/site/careers"
            sx={{
              mt:            4,
              textTransform: 'uppercase',
              letterSpacing: '0.5px',
            }}
          >
            {t('eos.landing_page.label.view_open_positions')}
          </Button>
        </Container>
      </main>

      <Display if={company.description}>
        <article>
          <Container
            sx={{ mt: 8, [theme.breakpoints.down('sm')]: { mt: 5, p: 3, bgcolor: theme.palette.grey['100'] } }}
          >
            <Typography
              variant="h3"
              color="primary"
              sx={{
                fontWeight:                     'bold',
                mb:                             3,
                [theme.breakpoints.down('sm')]: {
                  textAlign: 'center',
                },
              }}
            >
              {`${t('eos.landing_page.text.about_company', { company: company.name })}`}
            </Typography>
            <Typography
              variant="body"
              component="div"
              sx={{
                fontSize:   '.9rem',
                lineHeight: '1.5',
                a:          {
                  color:          'primary.main',
                  textDecoration: 'none',
                  '&:hover':      {
                    textDecoration: 'underline',
                  },
                },
              }}
            >
              {ReactHtmlParser(company.description)}
            </Typography>
          </Container>
        </article>
      </Display>

      <footer style={{ marginTop: 30 }}>
        <Footer
          name={company.name}
          logo={company.logo}
          showPrivacyPolicy={company.privacyPolicyLink}
        />
      </footer>

      <Display if={cookieNotification}>
        <CookieConsent
          location="bottom"
          buttonText="X"
          cookieName="talkpushCookies"
          style={{ background: theme.palette.primary.main, color: theme.palette.primary.contrastText, textAlign: 'center' }}
          buttonStyle={{
            background: '#FFFFFF', color: '#000000', fontSize: '13px', borderRadius: '50%',
          }}
          expires={150}
        >
          {t('eos.landing_page.consent')}
        </CookieConsent>
      </Display>
    </>
  );
}

/* ––
 * ––– Props declaration
 * –––––––––––––––––––––––––––––––– */
UnavailableCampaignPageIndex.propTypes = {};
UnavailableCampaignPageIndex.defaultProps = {};

/* ––
 * ––– Exports
 * –––––––––––––––––––––––––––––––– */
export default UnavailableCampaignPageIndex;
